module.exports = __webpack_public_path__ + "h5/img/home2.c1451f3f.png";